import { render, staticRenderFns } from "./announcement-details.vue?vue&type=template&id=a4af2a2c&"
import script from "./js/announcement-details.js?vue&type=script&lang=js&"
export * from "./js/announcement-details.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports